import { render, staticRenderFns } from "./AllPhrasesReport.vue?vue&type=template&id=37e0753c"
import script from "./AllPhrasesReport.vue?vue&type=script&lang=ts"
export * from "./AllPhrasesReport.vue?vue&type=script&lang=ts"
import style0 from "./AllPhrasesReport.vue?vue&type=style&index=0&id=37e0753c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports